const normalizeSplitTags = value => {
  if (Array.isArray(value)) {
    return value.filter(Boolean)
  }
  if (typeof value === 'string') {
    return value.split(/[、,，\s]+/).filter(Boolean)
  }
  return []
}

const normalizeWholeTags = value => {
  if (Array.isArray(value)) {
    return value.filter(Boolean)
  }
  if (typeof value === 'string') {
    return value ? [value] : []
  }
  return []
}

const toTagItems = (tags, isNew) => tags.map(text => ({ text, isNew }))

export const createHeaderDisplayTags = (patientData, isNewField) => {
  const checkNew = fields => (typeof isNewField === 'function' ? isNewField(...fields) : false)
  const diagnosisTags = normalizeSplitTags(patientData?.diagnosisTags)
  const manualTags = normalizeWholeTags(patientData?.diagnosisManualTags)
  const statusContextTags = normalizeWholeTags(patientData?.currentStatusMedicationAdherenceLabel)
  return [
    ...toTagItems(diagnosisTags, checkNew(['diagnosisTags'])),
    ...toTagItems(manualTags, checkNew(['diagnosisManualTags'])),
    ...toTagItems(statusContextTags, checkNew(['currentStatusMedicationAdherenceLabel']))
  ]
}
